import AMapLoader from "@amap/amap-jsapi-loader";
import {ElMessage} from 'element-plus'
import request from '@/service/request';
import { GetDataCityTotal, GetDataList, GetProjectList } from '@/service/api'
import { options } from "less";
const redBlock = require('../images/mb_block.png');
const COUNTRY = 'country';
const PROVINCE = 'province';
const CITY = 'city';
const DISTRICT = 'district';
const quarter = '2023 Q3'
export let districtExplorer;
let currentAreaNode = null;
let tipMarker = null;
let tipMarkerDiv = null;
let markerList = []; // 搜索的项目marker;
let isNeedClearMarkers = []; //需要remove的marker;
let mapDataInstanceMethods = null;
let isZoomEnd = true;
var colors = [
    "#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00",
    "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707",
    "#651067", "#329262", "#5574a6", "#3b3eac"
];
let moveCurrentCity = "";
export let currentZoomStr = COUNTRY;
let currentZoom = 4.85;
let isChangeCurrentZoom = false;
let currentAreaCode = 100000;
export let currentAreaCodes = [currentAreaCode, null, null, null];

const clearIsNeedClearMarkers = () => {
    isNeedClearMarkers.forEach(mk => {
        map.remove(mk);
    })
    isNeedClearMarkers = [];
}

export const setCurrentAreaCodes = (cityType, a, b, c) => {
    currentAreaCodes = [currentAreaCode, a, b, c];
    //currentZoomStr = cityType;
}

export const returnChinaMap = () => {
    currentAreaCodes = [currentAreaCode, null, null, null];
    map.setZoomAndCenter(4.5, [101.497428, 38.90923]);
}

export const hiddenMarkerList = (status) => {
    isNeedClearMarkers.forEach(item => {
        if (status.includes(item.buildngStatusCode)) {
            item.show();
        } else {
            item.hide();
        }
    })
}

export const createProvinceMarker = async (code = currentAreaCodes[1]) => {
    console.log("++++++++++++++++++++++++++++++++++", code,isChangeCurrentZoom);
    if (!isChangeCurrentZoom) return;
    clearIsNeedClearMarkers();
    let p = mapDataInstanceMethods.getSelectTypeValue() == 4 ? {groupname: mapDataInstanceMethods.getUrbanAgglomerationsValue()} : {provCode: code}
    let { data } = await request({
        url: GetDataCityTotal,
        method: 'post',
        data: {
            paramList: {
                quarter: quarter,
                isHighBar: mapDataInstanceMethods.getCurrentPageDataType()
            },
            ...p
        }
    })
    data.forEach(item => {
        let marker = new AMap.Marker({
            map,
            anchor: "center",
            position: new AMap.LngLat(item.gpsLon, item.gpsLat),
            content: `
                <div class='city-marker-box'>${item.city}<s></s></div>
            `
        });
        marker.on('click', async () => {
            // mapDataInstanceMethods.changeCityName(item.city);
            if (mapDataInstanceMethods.getSearchModel()) return;
            moveCurrentCity = item.city;
            map.setZoomAndCenter(10, [item.gpsLon, item.gpsLat])
            currentAreaCodes[2] = item.cityCode;
            mapDataInstanceMethods.changeCityCurrentModel([currentAreaCodes[1], currentAreaCodes[2]]);
        })
        isNeedClearMarkers.push(marker);
        map.add(marker);

        let polygons = map.getAllOverlays("polygon");
        for(let i=0; i<polygons.length; i++){
            if(polygons[i]._attched.adcode == item.cityCode){
                polygons[i].setOptions({
                    fillColor: "#4badff",
                    strokeColor: '#000'
                })
                break;
            }
        }
    })
}

export const createCityMarker = async (code = currentAreaCodes[2]) => {
    if (!code) return;
    clearIsNeedClearMarkers();
    let { data } = await request({
        url: GetDataList,
        method: "post",
        data: {
            paramList: {

            },
            quarter: quarter,
            isHighBar: mapDataInstanceMethods.getCurrentPageDataType(),
            cityCode: code
        }
    })

    data.forEach(item => {
        let marker = new AMap.Marker({
            map,
            position: new AMap.LngLat(item.gpsLon, item.gpsLat),
            //offset: new AMap.Pixel(17, 19),
            content: `
                <div class='area-marker-box'>
                    <div class='area-marker-icon'></div>
                    <div class='area-marker-info-box'>
                        <p class='area-marker-title'>${item.area}</p>
                    </div>
                    <div class='area-marker-info'>
                        <div class='area-markerinfo-line'>
                            <b>现有存量：</b>
                            <span>${item.areaTotal ? item.areaTotal.toLocaleString() : 0} ㎡</span>
                        </div>
                        <div class='area-markerinfo-line'>
                            <b>预估有效租金：</b>
                            <span>${item.estimatedEffective ? item.estimatedEffective.toFixed(2) : '0.00'} 元/㎡·月</span>
                        </div>
                    </div>
                </div>
            `
        });
        marker.cityCode = item.areaCode;
        marker.dom.onmouseenter = function (e) {
            //marker.dom.className = "amap-marker marker-z-index999";
            // marker.dom.querySelector('.area-marker-info-box').style.display = 'none';
            // marker.dom.querySelector('.area-marker-info').style.display = 'block';
        }

        marker.dom.onmouseout = function (e) {
            //marker.dom.className = "amap-marker";
            if (!marker.dom.contains(e.toElement)) {

                // marker.dom.querySelector('.area-marker-info-box').style.display = 'block';
                // marker.dom.querySelector('.area-marker-info').style.display = 'none';
            }

        }


        marker.on('click', async () => {
            if (mapDataInstanceMethods.getSearchModel()) return;
            // mapDataInstanceMethods.changeCityName(item.area);
            moveCurrentCity = item.area;
            map.setZoomAndCenter(12.94, [item.gpsLon, item.gpsLat])
            currentAreaCodes[3] = item.areaCode;
            mapDataInstanceMethods.changeCityCurrentModel(currentAreaCodes.slice(1));
        })
        isNeedClearMarkers.push(marker);
        map.add(marker);
    })
}

export function restoreProjectMarkerIcon(marker){
    let {buildingState} = marker.getExtData();
    let statusClass;
    if (buildingState == "已建成") {
        statusClass = "b1"
    } else if (buildingState == "部分建成") {
        statusClass = "b2"
    } else if (buildingState == "在建") {
        statusClass = "b3"
    }
    marker.dom.querySelector(".project-item-icon").className = `project-item-icon project-item-${statusClass}`;
}

function createProjectMarker(item, isCircle, index){
    let localList = localStorage.getItem("campareList");
    let list = localList ? JSON.parse(localList).filter(item => item) : [];
    let isCampare = !!list.find(citem => citem.rptId == item.rptId);
    item.isCampare = isCampare;
    item.isCircle = isCircle;

    if(isCircle){
        let isInIsNeedClearMarkers;

        for(let i=0; i<isNeedClearMarkers.length; i++){
            let m = isNeedClearMarkers[i];
            let oed = m.getExtData();
            if(item.rptId == oed.rptId){
                isInIsNeedClearMarkers = m;
            }else{
                m.setExtData({...oed, isCircle: false});
            }
        }
    
        if(isInIsNeedClearMarkers) {
            console.log(item,"--------------")
            item.marker = isInIsNeedClearMarkers;
            item.marker.setExtData({...item.marker.getExtData(), isCircle: true})
            item.marker.dom.querySelector('.project-item-icon').innerHTML = index+1;
            return;
        };
    }
    let dt = mapDataInstanceMethods.getCurrentPageDataType();
    let marker = new AMap.Marker({
        map,
        anchor: "center",
        position: new AMap.LngLat(item.gpsLon, item.gpsLat),
        cursor: "default",
        extData: item,
        //offset: new AMap.Pixel(0, -80),
        // content: `
        //     <div style='width:10px; height:10px; background:red'></div>
        // `
        content: `
            <div class='project-marker-box'>
                <div class='project-info-block'>
                    <div class='project-info-box'>
                        <div class='project-info-top ${item.buildingState == "已建成" ? "builded" : item.buildingState == "部分建成" ? "part-builded" : "build"}'>
                            <span>${item.projectName}</span>
                            <s>${item.buildingState}</s>
                        </div>
                        <div class='project-info-content'>
                            <div class='project-line-info'>
                                <span class='project-line-title'>建成面积</span>
                                <span class='project-line-text'><b>${item.areaTotal ? item.areaTotal.toLocaleString() : 0}</b> ㎡</span>
                            </div>
                            <div class='project-line-info'>
                                <span class='project-line-title'>空置率</span>
                                <span class='project-line-text'><b>${Number(item.vacancyRate * 100).toFixed(2)}%</b></span>
                            </div>
                            <div class='project-line-info'>
                                <span class='project-line-title'>在建面积</span>
                                <span class='project-line-text'><b>${item.buildingArea}</b> ㎡</span>
                            </div>
                            <div class='project-line-info'>
                                <span class='project-line-title'>建筑类型</span>
                                <span class='project-line-text'><b>${item.rptBuildingTypeNames}</b></span>
                            </div>
                            <div class='project-line-info'>
                                <span class='project-line-title'>预估有效租金</span>
                                <span class='project-line-text'><b>${item.effectiveRent ? item.effectiveRent.toFixed(2) : '-'}</b> 元/㎡·月</span>
                            </div>
                        </div>
                        ${
                            dt == 1 ? 
                            `
                            <div class='project-info-btns'>
                                <a href='javascript:;' class='project-info-camparebtn ${isCampare ? "campared" : ""}'>
                                    <s></s>
                                    <span>${isCampare ? '取消对比' : '加入对比'}</span>
                                </a>
                                <a href='javascript:;' class='project-info-collectbtn'>
                                    <s></s>
                                    <span>收藏项目</span>
                                </a>
                            </div>
                            `: ''
                        }
                        
                    </div>
                    <div class='project-item-name ${item.buildingState == "已建成" ? "builded" : item.buildingState == "部分建成" ? "part-builded" : "build"}'>${item.projectName}<s></s></div>
                </div>
                ${
                    dt == 2 ? 
                    `<div class='project-item-icon ${item.buildingState == "已建成" ? "project-item-b1" : item.buildingState == "部分建成" ? "project-item-b2" : "project-item-b3"}'></div>`
                    :
                    (
                        isCampare ? 
                        `<div class='project-item-icon project-item-b5'></div>`
                        :
                        (
                        isCircle ? 
                        `<div class='project-item-icon project-item-b4'>${index+1}</div>`
                        :
                        `<div class='project-item-icon ${item.buildingState == "已建成" ? "project-item-b1" : item.buildingState == "部分建成" ? "project-item-b2" : "project-item-b3"}'></div>`
                        )
                    )
                }
            </div>
        `
    });

    if (item.buildingState == "已建成") {
        marker.buildngStatusCode = 1;
    } else if (item.buildingState == "部分建成") {
        marker.buildngStatusCode = 2;
    } else if (item.buildingState == "在建") {
        marker.buildngStatusCode = 3;
    }

    marker.dom.onmouseover = function (e) {
        marker.dom.className = "amap-marker marker-z-index999";
        this.querySelector('.project-info-box').style.display = 'block';
        this.querySelector('.project-item-name').style.display = 'none';
    }

    marker.dom.onmouseout = function (e) {
        marker.dom.className = "amap-marker";
        this.querySelector('.project-info-box').style.display = 'none';
        this.querySelector('.project-item-name').style.display = 'block';
    }

    if(dt == 1){
        marker.dom.querySelector('.project-info-camparebtn').onclick = function(e){
        

            let {isCampare, isCircle, buildingState,rptId} = marker.getExtData();
            
            let vmList = mapDataInstanceMethods.getCircleSearchList();
            let currentItem = vmList.value.find(item => item.rptId == rptId);
            console.log(isCampare,vmList.value,"77777777777777777")
            if(isCampare){
                this.className = "project-info-camparebtn";
                this.querySelector('span').innerHTML = '加入对比';
                if(currentItem){
                    currentItem.isCampareModel = false
                }
                if(isCircle){
                    marker.dom.querySelector(".project-item-icon").className = "project-item-icon project-item-b4"
                }else{
                    restoreProjectMarkerIcon(marker);
                }
                
                let extData = {...marker.getExtData(), isCampare: false};
                marker.setExtData(extData);
                mapDataInstanceMethods.minusCompare(extData)
            }else{
                let localList = localStorage.getItem("campareList");
                let list = localList ? JSON.parse(localList) : [];
                if(list.length == 5){
                    ElMessage.error('最多添加5个对比项目');
                    return;
                }
                this.className = "project-info-camparebtn campared";
                this.querySelector('span').innerHTML = '取消对比';
                if(currentItem){
                    currentItem.isCampare = true;
                    currentItem.isCampareModel = true
                }
                marker.dom.querySelector(".project-item-icon").className = "project-item-icon project-item-b5"
                let extData = {...marker.getExtData(), isCampare: true};
                marker.setExtData(extData);
                mapDataInstanceMethods.addCampare(extData);
            }
            
        }
    }

    

    marker.on('click', async (e) => {
        // if (mapDataInstanceMethods.getSearchModel()) return;
        // if (e.originEvent.target.className.includes('project-item-name')) {
        //     e.originEvent.target.parentNode.children[0].className = 'project-info-box project-show-info'
        // }

        // if (e.originEvent.target.className.includes('project-close-icon')) {
        //     e.originEvent.target.parentNode.parentNode.className = 'project-info-box'
        // }
    })
    console.log(item,"xxxxxxxxxxxx")
    item.marker = marker;
    return marker;
}

export const getProjectListFn = async (code, filterOptions = {}) => {
    clearIsNeedClearMarkers();
    let param = {}
    if (currentZoomStr == CITY) {
        param = {
            cityCode: code.toString()
        }
    } else if (currentZoomStr == DISTRICT) {
        param = {
            areaCode: code.toString()
        }
    }
    
    let { data } = await request({
        url: GetProjectList,
        method: "post",
        data: {
            paramList: {},
            quarter: quarter,
            ...param,
            isHighBar: mapDataInstanceMethods.getCurrentPageDataType(),
            ...filterOptions
        }
    })


    data.forEach(item => {
        let marker = createProjectMarker(item);
        if(marker){
            isNeedClearMarkers.push(marker);
            map.add(marker);
        }
    })
}

export const delCompareDOM = (id) => {
    let l = [...isNeedClearMarkers,...circleMarkers];
    if(id == 'all'){
        l.forEach(marker => {
            marker.dom.querySelector('.project-info-camparebtn').className = "project-info-camparebtn";
            marker.dom.querySelector('.project-info-camparebtn span').innerHTML = '加入对比';
            let extData = {...marker.getExtData(), isCampare: false};
            marker.setExtData(extData);
            if(extData.isCircle){
                marker.dom.querySelector(".project-item-icon").className = `project-item-icon project-item-b4`;
            }else{
                restoreProjectMarkerIcon(marker);
            }
        })
    }else{
        let currentMarker = l.find(marker => {
            let {rptId} = marker.getExtData();
            return id == rptId;
        })
    
        if(currentMarker){
            currentMarker.dom.querySelector('.project-info-camparebtn').className = "project-info-camparebtn";
            currentMarker.dom.querySelector('.project-info-camparebtn span').innerHTML = '加入对比';
            let extData = {...currentMarker.getExtData(), isCampare: false};
            currentMarker.setExtData(extData);
            console.log(extData)
            if(extData.isCircle){
                currentMarker.dom.querySelector(".project-item-icon").className = `project-item-icon project-item-b4`;
            }else{
                restoreProjectMarkerIcon(currentMarker);
            }
        }
    }
}

export let map;

let circleMarker;
let circleEditor;
let drawCirclePoint;

function needClearMarkersInCircle(data){ //圈里的marker是否在搜索的园中
    let inCircleMarkers = isNeedClearMarkers.filter(marker => {
        let markerData = marker.getExtData();
        let current = data.find(item => item.rptId == markerData.rptId);
        let markerIcon;
        if(markerData.isCampare){
            markerIcon = "project-item-icon project-item-b5";
        }else{
            if(markerData.buildingState == '已建成'){
                markerIcon = "project-item-icon project-item-b1";
            }else if(markerData.buildingState == '部分建成'){
                markerIcon = "project-item-icon project-item-b2";
            }else{
                markerIcon = "project-item-icon project-item-b3";
            }
        }
        marker.dom.querySelector('.project-item-icon').className = markerIcon;
        marker.dom.querySelector('.project-item-icon').innerHTML = "";
        return !!current;      
    })

    inCircleMarkers.forEach(marker => {
        let {isCampare} = marker.getExtData();
        if(isCampare){
            marker.dom.querySelector('.project-item-icon').className = "project-item-icon project-item-b5"
        }else{
            marker.dom.querySelector('.project-item-icon').className = "project-item-icon project-item-b4"
        }
    })
}

let circleMarkers = [];
function createInCircleMarker(data){
    map.remove(circleMarkers);
    circleMarkers = [];
    needClearMarkersInCircle(data);
    data.forEach((item,index) => {
        let marker = createProjectMarker(item, true, index);
        if(marker){
            circleMarkers.push(marker);
            map.add(marker);
        }
    })
}

export const initAmap = async (resolve, instanceMethods) => {
    mapDataInstanceMethods = instanceMethods;
    let AMap = await AMapLoader.load({
        key: "f23dd75be6114f448fb655aae60bd5f2",
        version: "2.0",
        plugins: ['AMap.Scale', 'AMap.CircleEditor'],
        AMapUI: {
            plugins: ['overlay/SimpleMarker', 'geo/DistrictExplorer']
        }
    });
    //console.log(AMap)
    //"amap://styles/39e320c69a0d84f8a15f83f9cf29dbb3&ispublic=1"
    map = new AMap.Map('container', {
        center: [101.497428, 34.90923],
        viewMode: "3D",
        zoom: currentZoom,
        pitch: 20,
        // zoomEnable: false,
        doubleClickZoom: false,
        // scrollWheel: false,
        mapStyle: "amap://styles/whitesmoke",
        animateEnable: false,
        pitchEnable: false
    })

    map.on('complete', resolve)

    let oldPoint;

    function drawCircleMouseUp(e){
        console.log(456)
        map.setStatus({
            dragEnable: true,
            zoomEnable: true
        })

        oldPoint = null;

        map.off('mouseup', drawCircleMouseUp);
        // map.off('mousemove', drawCircleMouseMove)
    }

    function getDrawModel(){ //获取当前是否是绘画模式
        return currentZoomStr == DISTRICT && mapDataInstanceMethods.getShowRangeSearch() == 2;
    }

    function drawCircleMouseMove(e){
        let distance = Math.round(oldPoint.distance(e.lnglat));
        circleMarker.setRadius(distance);
        console.log(distance)
    }
    
    function createDrawCircle(point,radius){
        circleMarker = new AMap.Circle({
            center: point,
            radius: radius,
            fillColor: '#1477c9',
            fillOpacity: 0.2,
            strokeColor: '#136DD2',
            // bubble: true
        })

        map.add(circleMarker);
        if(!circleEditor){
            circleEditor = new AMap.CircleEditor(map, circleMarker);
            circleEditor.open();
            circleEditor.on('adjust', async () => {
                let radius = circleMarker.getRadius();
                let maxRadius = 20000;
                if(radius > maxRadius){
                    circleEditor.close();
                    circleMarker.remove();
                    circleMarker = null;
                    circleEditor = null;
                    createDrawCircle(drawCirclePoint, maxRadius);
                    ElMessage.error('圈选范围最多为20公里')
                }
                let data = await mapDataInstanceMethods.getDrawCircleData(drawCirclePoint.lng, drawCirclePoint.lat, radius/1000, isNeedClearMarkers)
                createInCircleMarker(data);
            })
            circleEditor.on('move', async (event) => {
                let radius = circleMarker.getRadius();
                drawCirclePoint = event.lnglat;
                let data = await mapDataInstanceMethods.getDrawCircleData(drawCirclePoint.lng, drawCirclePoint.lat, radius/1000, isNeedClearMarkers)
                createInCircleMarker(data);
            })
        }
    }

    map.on('mousedown',function(e){
        if(getDrawModel() && !circleMarker){
            console.log(e)
            
            drawCirclePoint = e.lnglat;
            
            createDrawCircle( e.lnglat, 10);

            

        }
    })

    map.addControl(new AMap.Scale());

    //console.log(AMapUI.DistrictExplorer)

    async function cityZoomendSearch(){ // 按省份、城市、区县查询时的zoomend
        console.log(currentAreaCodes,"xxx")
        let zoom = map.getZoom();
        if (mapDataInstanceMethods.getSearchModel()) {
            if (zoom < 5) {
                if (currentZoomStr != COUNTRY) {
                    isChangeCurrentZoom = true;
                    currentZoomStr = COUNTRY;
                    clearIsNeedClearMarkers();
                    switch2AreaNode(currentAreaCodes[0]);
                }
                mapDataInstanceMethods.setShowFilterOptions(false);
                mapDataInstanceMethods.tirggleShowDataInfo(false);
                mapDataInstanceMethods.showCampareInfo(0);
                map.setPitch(20);
            }
            return;
        }

        currentZoom = zoom;
        if (zoom < 5) {
            mapDataInstanceMethods.changeCityName("");
            if (currentZoomStr != COUNTRY) {
                console.log('9-9-9-9-9-9-9-9-9-9-9-9-8-8-8-8-8-')
                currentZoomStr = COUNTRY;
                districtExplorer.clearFeaturePolygons();
                clearIsNeedClearMarkers();
                switch2AreaNode(currentAreaCodes[0]);
            }
            mapDataInstanceMethods.setShowFilterOptions(false);
            mapDataInstanceMethods.setIsShowProjectFilter(false);
            mapDataInstanceMethods.tirggleShowDataInfo(false);
            // mapDataInstanceMethods.setShowRangeSearch(0);
            mapDataInstanceMethods.showCampareInfo(0);
            map.setPitch(20);
        } else if (zoom >= 5 && zoom < 9) {// xx
            console.log(currentAreaCodes,"000000000000000")
            mapDataInstanceMethods.changeCityName(moveCurrentCity);
            if (currentZoomStr != PROVINCE) {
                isChangeCurrentZoom = true;
                currentZoomStr = PROVINCE;
                if(mapDataInstanceMethods.getSelectTypeValue() == 4){
                    reDrawProvince();
                }else{
                    switch2AreaNode(currentAreaCodes[1]);
                }
                
                await createProvinceMarker(currentAreaCodes[1]);
                await instanceMethods.getRightPannelInfo(currentZoomStr, currentAreaCodes[1]);

            }
            mapDataInstanceMethods.setShowFilterOptions(false);
            mapDataInstanceMethods.setIsShowProjectFilter(false);
            mapDataInstanceMethods.tirggleShowDataInfo(true);
            mapDataInstanceMethods.setShowRangeSearch(0);
            mapDataInstanceMethods.showCampareInfo(0);
            map.setPitch(20);
        } else if (zoom >= 9 && zoom < 11) {
            console.log(currentAreaCodes,"0000000000000000000")
            mapDataInstanceMethods.changeCityName(moveCurrentCity);
            if (currentZoomStr != CITY) {
                isChangeCurrentZoom = true;
                currentZoomStr = CITY;
                switch2AreaNode(currentAreaCodes[2]);
                await createCityMarker(currentAreaCodes[2])
                await instanceMethods.getRightPannelInfo(currentZoomStr, currentAreaCodes[2]);
            }
            mapDataInstanceMethods.setShowFilterOptions(true);
            mapDataInstanceMethods.setIsShowProjectFilter(false);
            mapDataInstanceMethods.tirggleShowDataInfo(true);
            mapDataInstanceMethods.setShowRangeSearch(0);
            mapDataInstanceMethods.showCampareInfo(0);
            map.setPitch(20);
        } else {
            console.log(currentAreaCodes,'dis')
            mapDataInstanceMethods.changeCityName("");
            if (currentZoomStr != DISTRICT) {
                districtExplorer.clearFeaturePolygons();
                //currentZoomStr = DISTRICT;
                isChangeCurrentZoom = false;
                currentAreaNode = null;
                currentZoomStr = DISTRICT;
                await getProjectListFn(currentAreaCodes[3]);
            }
            mapDataInstanceMethods.setShowFilterOptions(true);
            mapDataInstanceMethods.setIsShowProjectFilter(true);
            mapDataInstanceMethods.tirggleShowDataInfo(false);
            let val = mapDataInstanceMethods.getShowRangeSearch() > 0 ? mapDataInstanceMethods.getShowRangeSearch() : 1;
            mapDataInstanceMethods.setShowRangeSearch(val);
            mapDataInstanceMethods.showCampareInfo(2);
            map.setPitch(0);
        }
        tipMarker.remove();
        setTimeout(() => {
            districtExplorer.on('featureMousemove', districtMouseMove);
        }, 1000)
    }


    async function cityGroupZoomendSearch(){
        let zoom = map.getZoom();
        console.log(zoom)
    }
    map.on('zoomend', (e, a, b, c) => {
        cityZoomendSearch()
    })

    districtExplorer = new AMapUI.DistrictExplorer({
        eventSupport: true,
        map
    })

    // map.on('mousemove', (e) => {
    //     if ((currentZoomStr == PROVINCE || currentZoomStr == CITY)) {
    //         districtExplorer.locatePosition(e.lnglat, function (error, routeFeatures) {
    //             if (routeFeatures && routeFeatures.length > 1) {
    //                 //切换到省级区域
    //                 let index;
    //                 if (currentZoomStr == PROVINCE) {
    //                     index = 1;
    //                 } else if (currentZoomStr == CITY) {
    //                     index = 2
    //                 }
    //                 switch2AreaNode(routeFeatures[index].properties.adcode);
    //             }
    //         }, {
    //             levelLimit: 3
    //         });
    //     }
    // })

    districtExplorer.on('outsideClick', function (e, feature) {
        console.log(mapDataInstanceMethods.getSearchModel())
        if (mapDataInstanceMethods.getSearchModel()) return;
        if (e.emitType == 'my') {
            currentZoomStr = e.cityType
        }

        if ((currentZoomStr == PROVINCE || currentZoomStr == CITY)) {
            districtExplorer.locatePosition(e.originalEvent.lnglat, async function (error, routeFeatures) {
                if (routeFeatures && routeFeatures.length > 1) {
                    //切换到省级区域
                    let index;
                    if (currentZoomStr == PROVINCE) {
                        index = 1;
                        mapDataInstanceMethods.changeCityCurrentModel([routeFeatures[1].properties.adcode], true);
                    } else if (currentZoomStr == CITY) {
                        index = 2
                        mapDataInstanceMethods.changeCityCurrentModel([routeFeatures[1].properties.adcode, routeFeatures[2].properties.adcode], true);
                    }
                    let properties = routeFeatures[index].properties;
                    let code = properties.adcode;
                    moveCurrentCity = properties.name;
                    if (currentZoomStr == PROVINCE) {
                        await createProvinceMarker(code);
                        await instanceMethods.getRightPannelInfo(currentZoomStr, code);
                    }
                    if (currentZoomStr == CITY) {
                        await createCityMarker(code);
                        await instanceMethods.getRightPannelInfo(currentZoomStr, code);
                    }

                    switch2AreaNode(code);

                    let zoom
                    if (e.emitType == 'my') {
                        zoom = e.zoom;
                    } else {
                        zoom = map.getZoom();
                    }
                    map.setZoomAndCenter(zoom, properties.center);
                    mapDataInstanceMethods.changeCityName(properties.name);
                }
            }, {
                levelLimit: 3
            });
        }
    });

    districtExplorer.on('featureMouseout featureMouseover', (e, feature) => {
        if (mapDataInstanceMethods.getSearchModel()) return;
        toggleHoverFeature(feature, e.type === 'featureMouseover', e.originalEvent ? e.originalEvent.lnglat : null)
        if (currentZoomStr == CITY) {
            let cityCode = feature.properties.adcode
            let findMarker = isNeedClearMarkers.find(item => {
                return item.cityCode == cityCode
            });
            if (e.type === 'featureMouseover') {
                if (findMarker) {
                    findMarker.dom.className = "amap-marker marker-z-index999";
                    findMarker.dom.querySelector('.area-marker-info-box').style.display = 'none';
                    findMarker.dom.querySelector('.area-marker-info').style.display = 'block';
                }
            } else {
                if (findMarker) {
                    findMarker.dom.className = "amap-marker";
                    findMarker.dom.querySelector('.area-marker-info-box').style.display = 'block';
                    findMarker.dom.querySelector('.area-marker-info').style.display = 'none';
                }
            }
        }

    })


    function cityMousemmoveSearch(e, feature){// 按省份、城市、区县查询时的move
        //更新提示位置
        if (mapDataInstanceMethods.getSearchModel()) return;
        let props = feature.properties;
        if (isChangeCurrentZoom && currentAreaCode != props.adcode) {
            if (props.level == currentZoomStr) {
                switch2AreaNode(props.adcode);
            }

            isChangeCurrentZoom = false;
        }
        if (currentZoomStr == COUNTRY) {
            currentAreaCodes[1] = props.adcode;
            tipMarker.dom.style.display = 'block';
            tipMarker.setPosition(e.originalEvent.lnglat);
        } else if (currentZoomStr == PROVINCE) {
            let pks = [110000,120000,310000,500000];
            if(pks.includes(currentAreaCodes[1])){
                currentAreaCodes[1] = props.acroutes[1];
                currentAreaCodes[2] = props.acroutes[1];
                currentAreaCodes[3] = props.adcode;
            }else{
                currentAreaCodes[1] = props.acroutes[1];
                currentAreaCodes[2] = props.adcode;
            }
            tipMarker.dom.style.display = 'none';
            // tipMarker.setPosition(e.originalEvent.lnglat);
        } else if (currentZoomStr == CITY) {
            let pks = [110000,120000,310000,500000];
            if(pks.includes(currentAreaCodes[1])){
                currentAreaCodes[1] = props.acroutes[1];
                currentAreaCodes[2] = props.acroutes[1];
                currentAreaCodes[3] = props.adcode;
            }else{
                currentAreaCodes[1] = props.acroutes[1];
                currentAreaCodes[2] = props.acroutes[2];
                currentAreaCodes[3] = props.adcode;
            }
            
            tipMarker.dom.style.display = 'none';
            //  tipMarker.setPosition(e.originalEvent.lnglat);
        } else {
            // console.log('xxxxxxxxxxxxxxxx',props)
            tipMarker.dom.style.display = 'none';
        }

        // e.originalEvent.originEvent.cancelBubble = true;
    }

    const districtMouseMove = (e, feature) => { // dm
        cityMousemmoveSearch(e, feature);
    }

    districtExplorer.on('featureMousemove', districtMouseMove);


    districtExplorer.on('featureClick', async function (e, feature) {
        if (mapDataInstanceMethods.getSearchModel()) return;

        districtExplorer.off('featureMousemove', districtMouseMove);
        if (feature.emitType != 'my') {
            if(mapDataInstanceMethods.getSelectTypeValue() != 4){
                mapDataInstanceMethods.changeCityCurrentModel([...feature.properties.acroutes.slice(1), feature.properties.adcode]);
            }
            var props = feature.properties;
            if (currentZoomStr == COUNTRY) {
                currentAreaCodes[1] = props.adcode;
            } else if (currentZoomStr == PROVINCE) {
                let pks = [110000,120000,310000,500000];
                if(pks.includes(props.acroutes[1])){
                    currentAreaCodes[1] = props.acroutes[1];
                    currentAreaCodes[2] = props.acroutes[1];
                    currentAreaCodes[3] = props.adcode;
                }else{
                    currentAreaCodes[1] = props.acroutes[1];
                    currentAreaCodes[2] = props.adcode;
                }
            } else if (currentZoomStr == CITY) {
                currentAreaCodes[1] = props.acroutes[1];
                currentAreaCodes[2] = props.acroutes[2];
                currentAreaCodes[3] = props.adcode;
            }
        } else {
            currentZoomStr = COUNTRY;
            map.setZoomAndCenter(4.85);
            await new Promise(resolve => {
                setTimeout(resolve,10)
            })
            let val = feature.val;
            // currentZoomStr = feature.cityType
            if(feature.val.length == 1){
                currentAreaCodes[1] = Number(val[0]);
                currentAreaCodes[2] = null;
                currentAreaCodes[3] = null;
            }else if(feature.val.length == 2){
                let pks = [110000,120000,310000,500000];
                if(pks.includes(Number(val[0]))){
                    currentAreaCodes[1] = Number(val[0]);
                    currentAreaCodes[2] = null;
                    currentAreaCodes[3] = null;
                }else{
                    currentAreaCodes[1] = Number(val[0]);
                    currentAreaCodes[2] = Number(val[1]);
                    currentAreaCodes[3] = null;
                }
                
            }else if(feature.val.length == 3){
                currentAreaCodes[1] = Number(val[0]);
                currentAreaCodes[2] = Number(val[1]);
                currentAreaCodes[3] = Number(val[2]);
            }
        }

        moveCurrentCity = feature.properties.name;
        if (feature.zoom == map.getZoom()) {
            mapDataInstanceMethods.changeCityName("");
            districtExplorer.clearFeaturePolygons();
            isChangeCurrentZoom = false;
            currentAreaNode = null;
            await getProjectListFn(currentAreaCodes[3]);
            currentZoomStr = DISTRICT;
            mapDataInstanceMethods.setShowFilterOptions(true);
            mapDataInstanceMethods.tirggleShowDataInfo(false);
            map.setCenter(feature.properties.center);
            return;
        }
        
        if(feature.emitType == 'my'){
            let levelLen = currentAreaCodes.filter(item => item);
            if(levelLen.length == 2){
                map.setZoomAndCenter(7, feature.properties.center)
            }else if(levelLen.length == 3){
                map.setZoomAndCenter(10, feature.properties.center)
            }else if(levelLen.length == 4){
                map.setZoomAndCenter(12.94, feature.properties.center)
            }
        }else{
            if (currentZoomStr == COUNTRY) {
                map.setZoomAndCenter(7, feature.properties.center)
            } else if (currentZoomStr == PROVINCE) {
                let pks = [110000,120000,310000,500000];
                if(pks.includes(currentAreaCodes[1])){
                    map.setZoomAndCenter(12.94, feature.properties.center)
                }else{
                    map.setZoomAndCenter(10, feature.properties.center)
                }
                
            } else if (currentZoomStr == CITY) {
                map.setZoomAndCenter(12.94, feature.properties.center)
            }
        }
        
    });

    tipMarkerDiv = document.createElement('div');
    tipMarkerDiv.className = "tipMarker top";
    tipMarker = new AMap.Marker({
        content: tipMarkerDiv,
        offset: new AMap.Pixel(0, 0),
        bubble: true
    });

    switch2AreaNode(currentAreaCode);
}

export const destroyAMap = () => {
    console.log('destroy')
}

export const reDrawCircle = () => {
    if(circleEditor){
        circleEditor.close();
        circleMarker.remove();
        circleMarker = null;
        circleEditor = null;
        drawCirclePoint = null;
        map.remove(circleMarkers);
        circleMarkers = [];
        isNeedClearMarkers.forEach(marker => {
            let {isCampare} = marker.getExtData();
            if(!isCampare){
                restoreProjectMarkerIcon(marker);
            }
        })
    }
    
}

export const removeMarkList = () => {
    markerList.forEach(marker => {
        map.remove(marker);
    })
    markerList = [];
}

export const createMarkers = (arr) => {
    removeMarkList();
    arr.forEach((item, index) => {
        let { projectName, gpsLat, gpsLon } = item;
        let m = createMarker({
            map,
            position: new AMap.LngLat(gpsLon, gpsLat),
            content: `
                <div class='country-marker'>
                    ${index + 1}
                    <div class='country-marker-anchor'>${projectName}<s></s></div>
                </div>
            `
        })

        m.dom.onmouseover = function (e) {
            if (mapDataInstanceMethods.getListItemShowIndex() > 0) return;
            e.target.parentNode.className = "amap-marker marker-z-index999";
            e.target.querySelector('.country-marker-anchor').style.display = "block"
            e.target.className = "country-marker country-markere-focus";
            m.isFocus = true;
        }

        m.dom.onmousemove = e => {
            e.stopPropagation();
        }

        m.dom.onmouseout = function (e) {

            if (mapDataInstanceMethods.getListItemShowIndex() > 0) return;
            e.target.className = "country-marker"
            e.target.querySelector('.country-marker-anchor').removeAttribute('style');
            m.dom.className = "amap-marker";
            m.isFocus = false;
        }

        m.dom.onclick = function () {
            mapDataInstanceMethods.listItemShowInfo(index);
        }

        markerList.push(m);
    })
}

export const hoverCurrentItem = (index) => {
    markerList.forEach(item => {
        if (item.isFocus) {
            let target = item.dom.children[0]
            target.children[0].removeAttribute('style');
            target.className = "country-marker";
            target.parentNode.className = "amap-marker";
            delete item.isFocus;
        }
    })


    let target = markerList[index].dom.children[0];
    markerList[index].isFocus = true;
    target.parentNode.className = "amap-marker marker-z-index999";
    target.children[0].style.display = "block"
    target.className = "country-marker country-markere-focus";
}

export const cancelHoverCurrentItem = () => {
    let current = markerList.find(item => item.isFocus);
    if (current) {
        let target = current.dom.children[0];
        target.children[0].removeAttribute('style');
        target.className = "country-marker";
        target.parentNode.className = "amap-marker";
        delete current.isFocus;
    }
}

export const setMapZooms = (t) => {
    console.log(map.getZooms())
    map.setZooms(t);
}

function createMarker(options) {
    let marker = new AMap.Marker(options);
    return marker;
}

function createMarketCountryContent(content) {
    let div = document.createElement('div');
    let text = document.createTextNode(content);
    div.className = "country-marker";
    div.appendChild(text);
    return div;
}


function reDrawProvince(){
    let list = mapDataInstanceMethods.getProvinceVoList();
    let areaNodes = [];
    districtExplorer.clearFeaturePolygons();
    list.forEach(item => {
        loadAreaNode(item.code, (error,areaNode) => {
            console.log(areaNode)
            areaNodes.push(areaNode);
            renderFeatures(areaNode);
        })
    })
    currentAreaNode = window.currentAreaNode = areaNodes[0];
    districtExplorer.setAreaNodesForLocating(areaNodes);
}

export const drawProvince = (name) => {
    map.setZoom(4.85, true);
    setTimeout(() => {
        moveCurrentCity = name;
        map.setZoom(5.5);
    },100)
}

function loadAreaNode(adcode, callback) {

    districtExplorer.loadAreaNode(adcode, function (error, areaNode) {

        if (error) {

            if (callback) {
                callback(error);
            }

            console.error(error);

            return;
        }

        // renderAreaPanel(areaNode);

        if (callback) {
            callback(null, areaNode);
        }
    });
}

function switch2AreaNode(adcode, callback) {
    if (currentAreaNode && ('' + currentAreaNode.getAdcode() === '' + adcode)) {
        return;
    }

    loadAreaNode(adcode, function (error, areaNode) {
        if (areaNode && areaNode._data.geoData.lngLatParent) {
            moveCurrentCity = areaNode._data.geoData.lngLatParent.properties.name;
            mapDataInstanceMethods.changeCityName(moveCurrentCity);
        }

        if (error) {

            if (callback) {
                callback(error);
            }

            return;
        }

        currentAreaNode = window.currentAreaNode = areaNode;

        //设置当前使用的定位用节点
        districtExplorer.setAreaNodesForLocating([currentAreaNode]);
        refreshAreaNode(areaNode);

        if (callback) {
            callback(null, areaNode);
        }
    });
}

function refreshAreaNode(areaNode) {
    districtExplorer.setHoverFeature(null);

    renderAreaPolygons(areaNode);
}


function renderFeatures(areaNode){
    console.log(areaNode,"------------------")
    //绘制子区域
    districtExplorer.renderSubFeatures(areaNode, function (feature, i) {

        var fillColor = colors[i % colors.length];
        var strokeColor = colors[colors.length - 1 - i % colors.length];
        return {
            cursor: 'default',
            bubble: true,
            strokeColor: "#83c7ff",
            fillColor: "#afd8fa",
            fillOpacity: 0.4,
            roofColor: "rgba(75,173,255,1)",
            wallColor: "rgba(43,139,218,1)"
        };
    });

    //绘制父区域
    districtExplorer.renderParentFeature(areaNode, {
        cursor: 'default',
        bubble: true,
        strokeColor: '#83c7ff', //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 1, //线宽
        fillColor: areaNode.getSubFeatures().length ? null : colors[0], //填充色
        fillOpacity: 0.35, //填充透明度
    });
}

function renderAreaPolygons(areaNode) {
    //更新地图视野
    //map.setBounds(areaNode.getBounds(), null, null, true);

    //清除已有的绘制内容
    districtExplorer.clearFeaturePolygons();

    renderFeatures(areaNode);
}

function toggleHoverFeature(feature, isHover, position) {

    if (currentZoomStr == COUNTRY) {
        tipMarker.setMap(isHover ? map : null);
    }



    if (!feature) {
        return;
    }
    

    var props = feature.properties;

    if (isHover) {

        //更新提示内容
        // $tipMarkerContent.html(props.adcode + ': ' + props.name);
        tipMarkerDiv.innerHTML = props.name;
        //更新位置
        tipMarker.setPosition(position || props.center);
    }

    //更新相关多边形的样式
    var polys = districtExplorer.findFeaturePolygonsByAdcode(props.adcode);
    console.log(props.adcode,"99999999999")
    for (var i = 0, len = polys.length; i < len; i++) {
        let item = polys[i];
        if (item) {
            if (isHover) {
                let extrusionHeight;
                if (currentZoomStr == COUNTRY) {
                    extrusionHeight = 50000
                } else if (currentZoomStr == PROVINCE) {
                    extrusionHeight = 15000
                } else if (currentZoomStr == CITY) {
                    extrusionHeight = 2500
                }
                item.setExtrusionHeight(extrusionHeight);
            } else {
                item.setExtrusionHeight(0);
            }
        }
    }
}